import { useGetDevicesInActivity } from 'api';
import { DeviceInfo } from 'oas';
import * as React from 'react';
import { actDicHasData } from 'shared';

export const useGetUnmappedDevices = (activityId: string): DeviceInfo[] | undefined => {
    const { data: devicesRaw } = useGetDevicesInActivity(activityId);

    return React.useMemo(
        () =>
            devicesRaw
                ?.filter((device) => {
                    // Show unmapped devices (no athlete_id) that have data (has_data, SD, munged)
                    if (!device.athlete_id) {
                        for (let i = 0; i < device.activity_dictionaries.length; i++) {
                            const actDic = device.activity_dictionaries[i];
                            if (actDicHasData(actDic)) {
                                return true;
                            }
                        }
                    }

                    return false;
                })
                .sort((a, b) => a.device_id - b.device_id),
        [devicesRaw],
    );
};
